import canAny from '../helpers/canAny';
import can from '../helpers/can';
import store from '../store';

export default function auth({next, to, router}) {
    store.dispatch('user/me').then(() => {
        const requiredPermissions = to.meta.permissions;
        const requiredPermissionsAny = to.meta.permissionsAny;

        store.dispatch('permission/get').then(() => {
            if (requiredPermissions){
                const canEnter = can(requiredPermissions);
                if (canEnter) {
                    return next();
                }
            }
            else if (requiredPermissionsAny){
                const canEnter = canAny(requiredPermissionsAny);
                if (canEnter) {
                    return next();
                }
            }
            else if (!requiredPermissions && !requiredPermissionsAny){
                return next();
            }

            return router.push({name: 'Dashboard'});
        });


    }).catch(() => {
        store.dispatch('user/logoutUser')
            .then(() => {
                router.push({name: 'AuthLogin'});
            })
    });
}